module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external "@material/react-line-ripple/dist/index.js"
// module id = 6
// module chunks = 4 5 10 11